import { CodeArticleVersion } from '@livv/models';
import { Container, Grid } from '@mui/material';
import { FC } from 'react';
import SideContent from './SideContent';
import DisplayFullText from '@components/FullText/DisplayFullText';
import { addArticleLink } from '@utils/parsing';

interface VersionContentProps {
    articleId: string;
    title: string;
    versionSelected: CodeArticleVersion;
}

const VersionContent: FC<VersionContentProps> = ({ articleId, title, versionSelected }) => {
    const { lienCitations, lienConcordes, texteHtml } = versionSelected;

    return (
        <Grid spacing={4} container>
            <Grid lg={8} md={6} item>
                <Container
                    maxWidth="sm"
                    sx={{
                        '& p': {
                            m: 0,
                            mb: 2,
                        },
                        '&.MuiContainer-root': {
                            marginLeft: 'unset',
                            p: 0,
                        },
                        borderTop: 'none',
                    }}
                >
                    <DisplayFullText
                        containerSx={{ mt: 0 }}
                        contentSx={{ textAlign: 'initial' }}
                        parseOptions={{ replace: addArticleLink }}
                        unsanitizedContent={texteHtml}
                        withSearch
                    />
                </Container>
            </Grid>
            <Grid lg={4} md={6} item>
                <SideContent
                    articleId={articleId}
                    lienCitations={lienCitations}
                    lienConcordes={lienConcordes}
                    title={title}
                />
            </Grid>
        </Grid>
    );
};

export default VersionContent;
